export default __webpack_public_path__ + "5ee9170b26ae8ca77d3c706d04714962.png";